module.exports = __webpack_public_path__ + "static/media/iconListView.91b39a14.svg";